import React from "react";
import "./Searchnav.css";
import WelcomeName from "./WelcomeName";
import { NavLink } from "react-router-dom";
function Searchnav() {
  return (
    <>
      <div class="searchnav-container">
        <div class="searchnav-wrap">
          <div class="searchnav-row">
            <div class="searchnav-box">
              <img
                src="images/Acc_Logo_Black_Purple_RGB.png"
                class="acc-logo"
                alt="logo"
              />
              <p class="desktop-tag">
                <span>Learning & Talent Transformation</span> <br />{" "}
                <p className="desktop-tag-1">Inclusion & Diversity</p>
              </p>
              <p class="mobile-tag">
                <span>L&TT</span> <br /> <p className="mobile-tag-1">ID</p>
              </p>
              {/* <NavLink to="/home"><img src="images/Home/home-icon-purple.png" class="home-icon" alt="homeicon" /></NavLink> */}
            </div>
          </div>
          <div class="searchnav-row">
            <div
              class="searchnav-box"
              style={{ textAlign: "right", marginTop: "10px" }}
            >
              {/* <p>Hello {sessionStorage.getItem("empName")}!</p> */}
              {/* <p>Hello !</p> */}
              <WelcomeName />
              <img src="images/Avatar.png" class="user-img" alt="user-image" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Searchnav;
